import { render, staticRenderFns } from "./reisetermin-view-header.vue?vue&type=template&id=496ebf76"
import script from "./reisetermin-view-header.vue?vue&type=script&lang=js"
export * from "./reisetermin-view-header.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-view-header.vue?vue&type=style&index=0&id=496ebf76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports